import request from '@/utils/request'

/**
 * 合集分页
 * @param data
 */
export const collectionList = (data) => {
  return request({
    url: '/sol/wap/biz_list',
    method: 'get',
    params: data
  })
}

/**
 * 合集详情
 * @path id
 */
export const collectionDetail = (id) => {
  return request({
    url: `/sol/wap/biz_list/${id}`,
    method: 'get'
  })
}

/**
 * 合集方案分页
 * @param data
 */
export const collectionSolutionsList = (id, data) => {
  return request({
    url: `/sol/wap/biz_list/${id}/solutions`,
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/collection/collection.js